import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import ToggleButton from '../../components/editais/ToggleButton';
import ToggleContent from '../../components/editais/ToggleContent';

function ProcessoSeletivo() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleContent = () => {
    setIsVisible(!isVisible);
  };

  return (
    <Container className="mt-5">
      <div className="row g-3 justify-content-center  mb-5">
        <div className="col-md-8 mt-3">
          {/* <h2>Inscrições</h2> */}
           <h2 className="mb-4">
            {" "}
            <strong>
              {" "}
              PROCESSO SELETIVO Nº 002/2026 ANALISTA DE DESENVOLVIMENTO WEB FULLSTACK{" "}
            </strong>
          </h2>
          
          <div className="mb-4">
            <p>
              {" "}
              O Projeto Web Academy, executado pelo IComp/UFAM em cooperação com a Motorola Mobility, torna pública a abertura de processo seletivo para contratação de Analista de Desenvolvimento Web Full Stack.
            </p>
          </div>
          
          <div className="mb-4">
            <div className="medium text-muted">16 de Maio, 2026</div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="files/processo_seletivo_edital_002_2026/Processo_Seletivo_002_2026_-Analista_de_Desenvolvimento.docx_assinado.pdf"
            >
              <h4>Edital 002/2026 - Seleção de candidatos</h4>
            </a>
          </div>
          {/*
          <div className="mb-4">
            <div className="maedium text-muted">
              19 a 28 de Fevereiro, 2026
            </div>
            {/* <a target="_blank" rel="noopener noreferrer" href="https://forms.gle/8sDb5bBjuoct5Zt46"> }
              <h4>Formulário para Requerimento de Inscrição (encerrado)</h4>
            {/* </a> }
          </div>
          <div className="mb-4">
            <div className="maedium text-muted">04 de Março, 2026</div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Preliminar_Homologação_e_Primeira_Fase.pdf"
            >
              <h4>Resultado Preliminar da Homologação e da Primeira Fase</h4>
            </a>
          </div>
           <div className="mb-4">
            <div className="maedium text-muted">10 de Março, 2026</div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Homologacao_e_Primeira_Fase_Convocacao.pdf"
            >
              <h4>
                Resultado Final da Primeira Fase e Convocação para 2ª Etapa
              </h4>
            </a>
          </div>
          <div className="mb-4">
            <div className="maedium text-muted">20 de Março, 2026</div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Preliminar_da_Segunda_Fase.pdf"
            >
              <h4>Resultado Preliminar da 2ª Etapa</h4>
            </a>
          </div>
         <div className="mb-4">
            <div className="maedium text-muted">24 de Março, 2026</div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_da_Segunda_Fase.pdf"
            >
              <h4>Resultado Final da 2ª Etapal</h4>
            </a>
          </div>
          <div className="mb-4">
            <div className="maedium text-muted">29 de Março, 2026</div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Final_Preliminar.pdf"
            >
              <h4>Resultado Final Preliminar</h4>
            </a>
          </div>
          <div className="mb-4">
            <div className="maedium text-muted">31 de Março, 2026</div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Final.pdf"
            >
              <h4>Resultado Final</h4>
            </a>
          </div> */}
          {/* <div className="mb-4">
						<div className="small text-muted">30 de Maio, 2025</div>
							<a target="_blank" rel="noopener noreferrer" href="files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Resultado_Preliminar_da_Etapa_1.pdf">
								<h4>Resultado Preliminar da Etapa 1</h4>
							</a>
					</div>

									<div className="mb-4">
										<div className="small text-muted">2 de Junho, 2025</div>
										<a target="_blank" rel="noopener noreferrer" href="files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Resultado_Final_da_Etapa_1.pdf">
											<h4>Resultado Final da Etapa 1</h4>
										</a>
									</div>

									<div className="mb-4">
										<div className="small text-muted">5 de Junho, 2025</div>
										<a target="_blank" rel="noopener noreferrer" href="files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Resultado_Final_Preliminar.pdf">
											<h4>Resultado Final Preliminar</h4>
										</a>
									</div>

									<div className="mb-4">
										<div className="small text-muted">7 de Junho, 2025</div>
										<a target="_blank" rel="noopener noreferrer" href="files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Resultado_Final.pdf">
											<h4>Resultado Final</h4>
										</a>
									</div> */}
          {/* <div className="mb-4" style={{ backgroundColor: '#ecf0f1', padding: '20px', marginBottom: '50px' }}>
										<div className="small text-muted">3 de Junho, 2025</div>
										{/* <a target="_blank" rel="noopener noreferrer" href="files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Resultado_Final_da_Etapa_1.pdf"> }
											<h4>🚨 🚨 Edital 003/2025 - Informações para Etapa 2 🚨 🚨</h4>
										{/* </a> }

										<br />

										<p>Prezados(as) Candidatos(as), <br /><br />
											As orientações para realização da Etapa 2 serão passadas por e-mail a partir das 12h do dia 05/06/2025. <br /><br />
											A Etapa 2 será realizada às 19h. <br /><br />
											Atenciosamente,</p>
									</div> */}
          {/* <div className="mb-4">
										<div className="small text-muted">09 de Julho, 2024</div>
										<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2024/Projeto Web Academy - Edital 002_2024 - Convocacao para Etapa 2.pdf">
											<h4>Convocação para Etapa 2</h4>
										</a>
									</div>

									<div className="mb-4">
										<div className="small text-muted">17 de Julho, 2024</div>
										<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2024/Projeto Web Academy - Edital 002_2024 - Selecao de Discentes - ERRATA01.pdf">
											<h4>ERRATA 01 - Edital 002/2024 </h4>
										</a>
									</div>

									<div className="mb-4">
										<div className="small text-muted">18 de Julho, 2024</div>
										<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2024/Projeto_Web_Academy_Edital 002_2024_Resultado_Final_Preliminar.pdf">
											<h4>Resultado Final Preliminar</h4>
										</a>
									</div>

									<div className="mb-4">
										<div className="small text-muted">22 de Julho, 2024</div>
										<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2024/Projeto_Web_Academy_Edital_002_2024_Resultado_Final.pdf">
											<h4>Resultado Final</h4>
										</a>
									</div>  */}
          {/* <div className="mb-4">
										<div className="small text-muted">May 5, 2023</div>
										<a className="link-dark" href="#!"><h4>Bootstrap 5 has officially landed</h4></a>
									</div>

									<div className="mb-4">
										<div className="small text-muted">Apr 21, 2023</div>
										<a className="link-dark" href="#!"><h4>This is another news article headline, but this one is a little bit longer</h4></a>
									</div> */}{' '}
          <br /> <br /> <br />
          <section>
            <div>
              <div className="row gx-5">
                <div className="col">
                  {/* <div className="mb-4">
										<h2> Em breve inscrições para Turma 5!!!</h2>
										<img src="assets/img/ampulheta.gif" alt="https://icons8.com/icon/TmIKpxTOSBi7/hourglass" />
									</div> */}

                  {/* <section className="py-4" style={{ backgroundColor: '#ecf0f1', padding: '20px', marginBottom: '50px' }}>
										<h2 className="mb-4"> <strong> Edital 002/2025 - 1ª Turma EaD </strong></h2>

										<div className="mb-4">
											<p> Este edital destina-se à formação da 1ª turma EaD do Projeto Web Academy para residentes em <strong>Benjamin Constant</strong>, <strong>Tabatinga</strong> e <strong>Atalaia do Norte</strong>, no Amazonas.</p>
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">10 de Março, 2025</div>
											<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Selecao_de_Discentes_Turma_1_EaD.pdf"><h4>Edital 002/2025 - Seleção de Discentes</h4></a>
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">14 a 30 de Março, 2025</div>
											{/* <a target="_blank" rel="noopener noreferrer" href="https://forms.gle/oxwZ1LFc59Bd98bp6"> }
												<h4>Formulário para Requerimento de Inscrição (Encerrado)</h4>
											{/* </a> }
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">05 de Abril, 2025</div>
											<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2025_ead/Projeto_Web_Academy_ Edital_002_2025_Errata_01.pdf"><h4>Errata 01 - Edital 002/2025 </h4></a>
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">05 de Abril, 2025</div>
											<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Preliminar_da_Homologacao.pdf"><h4>Resultado Preliminar da Homologação</h4></a>
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">11 de Abril, 2025</div>
											<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final_da_Homologacao_Preliminar_da_Etapa_1.pdf"><h4>Resultado Final da Homologação e Preliminar da Etapa 1</h4></a>
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">14 de Abril, 2025</div>
											<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final_da_Etapa_1.pdf"><h4>Resultado Final da Etapa 1</h4></a>
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">22 de Abril, 2025</div>
											<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final_Preliminar.pdf"><h4>Resultado Final Preliminar</h4></a>
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">23 de Abril, 2025</div>
											<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final.pdf"><h4>Resultado Final</h4></a>
										</div>

										<div className="mb-4">
											<div className="maedium text-muted">24 de Maio, 2025</div>
											<a target="_blank" rel="noopener noreferrer" href="files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final_Distribuicao_de_Bolsas_Preliminar.pdf"><h4>Resultado Final Preliminar - Distribuição de Bolsa</h4></a>
										</div>

									</section>									 */}
                  <ToggleButton
                    isVisible={isVisible}
                    toggleContent={toggleContent}
                  />
                </div>
              </div>
            </div>
          </section>
          <ToggleContent isVisible={isVisible} />
        </div>
      </div>
    </Container>
  );
}

export default ProcessoSeletivo;
